import "./index.css";
import "./extensions";
import ReactDOM from "react-dom/client";
import App from "./App";
import i18n from "./translations/i18n";

import { initSentry } from "./sentry";
import { ErrorBoundary } from "@sentry/react";
import { I18nextProvider } from "react-i18next";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GOOGLE_CLIENT_ID } from "./constants/environment";

// Before the site renders, so Sentry hears of its errors.
initSentry();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
  // Reports what crashes while rendering. Without a fallback, the page stays
  // empty then, as it did before.
  <ErrorBoundary>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </GoogleOAuthProvider>
  </ErrorBoundary>
  // </React.StrictMode>
);
